<ng-container *ngrxLet="viewModel$; let model;">
  <div class="action-button"
       [matMenuTriggerFor]="ccSyncMenu">
    <div class="iconContainer">
      @if (!model?.ccSyncLoading) {
        <mat-icon [svgIcon]="model.ccSyncIcon?.svgName"
                  [ngClass]="model.ccSyncIcon?.class"/>
      } @else {
        <mat-spinner [diameter]="24"></mat-spinner>
      }
    </div>
    <div [ngClass]="['label-small', model.ccSyncIcon?.class]">Start CC refresh</div>
  </div>


  <mat-menu #ccSyncMenu="matMenu">
    <div class="flex flex-col w-[360px]
                p-6"
         (click)="$event.stopPropagation()">

      <span class="label pb-1">CC refresh</span>

      <div class="flex flex-col">
        <div class="flex flex-row">
          <mat-icon [class]="model.ccSyncIcon?.class"
                    [svgIcon]="model.ccSyncIcon?.svgName"/>
          <span [class]="'pl-2 title ' +
                          model.ccSyncIcon?.class">{{
              ('ADDRESS_LIST.CC_SYNC.' + model.ccSyncStatus) | translate
            }}</span>
        </div>

        @if (model.ccSyncStatus === ccSyncStatus.PROCESSING) {
          <mat-progress-bar class="py-1"
                            mode="indeterminate"/>
        } @else {
          <div class="h-2"></div>
        }

        <div class="flex flex-row w-full justify-between
                    body-large pb-6">
          <span>{{ model.elapsedTime }}</span>
        </div>

        <div class="flex flex-row pb-6 gap-x-4">

          <div class="flex flex-col w-1/2">
            <span
                class="label">CC refresh start</span>
            <span class="body-large">{{
                model.ccSyncDetails?.startDate ?
                    (model.ccSyncDetails?.startDate | date:'dd.MM.yyyy, HH:mm') : 'n/a'
              }}</span>
          </div>

          <div class="flex flex-col w-1/2">
            <span
                class="label">Last CC refresh</span>
            <span class="body-large">{{
                model.ccSyncDetails?.endDate ?
                    (model.ccSyncDetails?.endDate | date:'dd.MM.yyyy, HH:mm') : 'n/a'
              }}</span>
          </div>

        </div>

      </div>

      @if (doesStatusAllowToScheduleSync(model.ccSyncStatus)) {
        <div class="flex p-4 mb-6 items-start gap-x-2 self-stretch rounded-[16px] bg-orange-80">
          <mat-icon class="min-w-6" svgIcon="report_problem_outline"/>
          <span class="body-medium">Refreshing CC results is expensive. Please only refresh when necessary.</span>
        </div>
      }

      <div class="flex flex-row justify-between items-center h-[36px] loadDetailsButton">
        <button mat-icon-button
                (click)="refreshCCSyncDetails()"
                class="text-neutral-30"
                matTooltip="Refresh"
                [disabled]="model.ccSyncLoading">
          <mat-icon svgIcon="refresh" [ngClass]="{ loading: model.ccSyncLoading }"></mat-icon>
        </button>
        <div
            matTooltip="{{ model.ccSyncStatus === ccSyncStatus.FINISHED ? 'Can be triggered once per 24' : '' }}"
            class="relative">
          <button #restartButton
                  (click)="restartCCSync()"
                  mat-flat-button
                  [disabled]="!doesStatusAllowToScheduleSync(model.ccSyncStatus) || model.ccSyncLoading">
            Start CC refresh
          </button>

        </div>
      </div>

    </div>
  </mat-menu>
</ng-container>


